var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 7.49999,15 C 8.3284,15 9,14.3284 9,13.5 V 9 h 4.5 C 14.3284,9 15,8.3284 15,7.5 15,6.67158 14.3284,6 13.5,6 H 9 V 1.5 C 9,0.67157 8.3284,0 7.49999,0 c -0.82843,0 -1.5,0.67157 -1.5,1.5 V 6 H 1.5 C 0.67157,6 0,6.67158 0,7.5 0,8.3284 0.67157,9 1.5,9 h 4.49999 v 4.5 c 0,0.8284 0.67158,1.5 1.5,1.5 z",
    fill: "#4D4D4D",
    id: "path1",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWhite);
export default __webpack_public_path__ + "static/media/add-white.e62aa461.svg";
export { ForwardRef as ReactComponent };